export interface ApplicationCheckListType {
  id: number;
  project_id: number;
  folder_id: number;
  title: string;
  expected_date?: string|null;
  instruction_date?: string|null;
  status: "Received" | "In Progress" | "Pending";
  path?: string | null;
  file_extension?: string | null;
  file_upload_date?: string | null;
}


// to single object maping
export const mapApplicationCheckListType = (data: any): ApplicationCheckListType => {
    if (!data) {
        throw new Error('Invalid Data')
    }

    const singleData: ApplicationCheckListType = {
        id: data.id,
        project_id: data.project_id,
        folder_id: data.folder_id,
        title: data.title ,
        expected_date:(data.expected_date!==null)? data.expected_date:null,
        instruction_date:(data.instruction_date!==null)? data.instruction_date:null,
        status: data.status,
        path: (data.path!==null)?data.path: null,
        file_upload_date:(data.file_upload_date!==null)? data.file_upload_date:null,
        file_extension:(data.file_extension!==null)? data.file_extension:null,
    }

    return singleData;
}

// maping list objects
export const mapApplicationCheckListTypes = (data: any[]): ApplicationCheckListType[] => {
    if (!Array.isArray(data)) {
        throw new Error('Invalid Data');
    }

    return data.map(mapApplicationCheckListType);
}